import { useQuery } from "@tanstack/react-query";
import { partyApi } from "@/lib/party.api";
import { queryKeys } from "@/lib/query-keys";
import { isValidRecordId } from "@/lib/route-id";

export function useParty(partyId: number) {
  return useQuery({
    queryKey: queryKeys.party(partyId),
    enabled: isValidRecordId(partyId),
    queryFn: () => partyApi.getById(partyId).then((r) => r.data),
  });
}
